import React from "react";

import { Flex, Grid, Text } from "atoms";
import MemoClose from "assets/icons/Close";

export const ClosableChips = ({ name, onClick }) => {
  return (
    <Flex bg="secondary.50" borderRadius="1rem" p="2px 8px" height="2.8rem" alignItems="center">
      <Text
        color="neutral.800"
        fontSize="1.4rem"
        fontFamily="NeometricBold"
        textTransform="capitalised"
      >
        {name}
      </Text>
      <Grid
        ml="1rem"
        height="2rem"
        width="2rem"
        borderRadius="2rem"
        bg="secondary.700"
        placeItems="center"
        color="white"
        onClick={onClick}
        cursor="pointer"
      >
        <MemoClose height="1rem" width="1rem" />
      </Grid>
    </Flex>
  );
};
